<template>
  <Popover v-slot="{ open, close }">
    <Float
      :offset="10"
      :auto-placement="{
        autoAlignment: true,
        allowedPlacements: ['bottom-end', 'top-end']
      }"
      :middleware="floatingMiddleware"
    >
      <PopoverButton
        :class="
          open
            ? 'border border-primary-400 dark:border-primary-500'
            : 'text-opacity-90 border'
        "
        class="group hover:text-opacity-100 inline-flex min-h-9 items-center justify-between gap-1 rounded-md px-3 py-2 font-medium"
        @click="popoverOpened = !popoverOpened"
      >
        <FontAwesomeIcon
          v-if="isLoading"
          :icon="['fal', 'spinner-third']"
          class="animate-spin"
        />
        <FontAwesomeIcon v-else :icon="['fal', 'gears']" />
        <span class="text-xs font-medium capitalize-first">
          {{ $t('global.view') }}
        </span>
        <FontAwesomeIcon
          class="group-hover:text-opacity-80 h-4 transition duration-150 ease-in-out"
          :class="popoverOpened ? '' : 'text-opacity-70'"
          :icon="['fas', 'caret-down']"
        ></FontAwesomeIcon>
      </PopoverButton>
      <PopoverPanel
        class="popover-panel flex max-h-[inherit] w-screen max-w-sm flex-col"
      >
        <div class="flex min-h-0 flex-col gap-2 px-3 py-2">
          <div class="relative flex shrink-0 flex-row items-center gap-2">
            <h1 class="flex-1 text-xl leading-none font-bold capitalize">
              {{ $t('global.display_options') }}
            </h1>
          </div>
          <div class="min-h-0 overflow-y-auto">
            <slot name="display-options-content" :close="close" />
          </div>
        </div>
      </PopoverPanel>
    </Float>
  </Popover>
</template>
<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Float } from '@headlessui-float/vue'
import { floatingMaxHeight } from '@u/floatingMaxHeight'

export default {
  name: 'DisplayOptionsComponent',
  components: { Float, FontAwesomeIcon, PopoverPanel, Popover, PopoverButton },
  data() {
    return {
      popoverOpened: false,
      isLoading: false,
      floatingMiddleware: [floatingMaxHeight(10)]
    }
  },
  computed: {},
  methods: {}
}
</script>
